import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPagination = styled('div')`
  .pagination-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-image {
    display: unset !important;
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  .ant-pagination-prev {
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 24px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .form-container {
      display: none;
    }

    .products-wrapper {
      padding-right: 0;

      .products {
        justify-content: center !important;
        padding: 0;
      }

      .category_name {
        text-align: center;
        display: block;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .ant-pagination-prev {
    margin-inline-end: 24px !important;
  }

  .ant-pagination-next {
    margin-inline-start: 24px !important;
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-card-bordered {
      min-width: 100%;
      max-height: 135px;
    }

    .ant-pagination-prev {
      margin-inline-end: 6px !important;
    }

    .ant-pagination-next {
      margin-inline-start: 6px !important;
    }

    .ant-pagination-prev {
      margin-right: 6px;
    }

    .ant-pagination-next {
      margin-left: 6px;
    }
  }

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    font-family: ${({ theme }) => theme.fontText} !important;
  }
`;
